import Vue from 'vue';
export default Vue.extend({
    name: 'offline',
    data: function () {
        return {
            tableData: [
                {
                    msg: '汇款信息',
                    category: '开户名称',
                    content: '北京方向无限科技有限公司',
                },
                {
                    msg: '',
                    category: '银行账号',
                    content: '1109 3579 7410 808',
                },
                {
                    msg: '',
                    category: '开户行',
                    content: '招商银行北京东三环支行',
                },
            ],
        };
    },
    methods: {
        copyData: function (data) {
            var copyinput = document.getElementById('copy-textarea');
            copyinput.value = data;
            copyinput.select();
            document.execCommand('copy');
            this.$message({
                type: 'success',
                message: '复制成功！',
            });
        },
        spanMethod: function (_a) {
            var rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
            if (columnIndex === 0) {
                if (rowIndex === 0) {
                    return {
                        rowspan: 3,
                        colspan: 1,
                    };
                }
                else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }
            }
        },
        className: function (_a) {
            var rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
            if (rowIndex === 1 && columnIndex === 2) {
                return 'number-medium';
            }
        },
    },
});
